module.exports = __webpack_public_path__ + "img/20210604_KSAF_AGH_SolarBoatZawody2021_MSzmigiel_021.699a57f9.webp";